// ConfettiAnimation.js
import { useEffect } from "react";
import confetti from "canvas-confetti";

export default function ConfettiAnimation({ trigger = false }) {
  useEffect(() => {
        if (!trigger) return; // Only run when triggered
    const canvas = document.createElement("canvas");
    canvas.style.position = "fixed";
    canvas.style.top = "0";
    canvas.style.left = "0";
    canvas.style.width = "100%";
    canvas.style.height = "100%";
    canvas.style.pointerEvents = "none"; // don’t block clicks
    canvas.style.zIndex = "9999"; // 👈 force on top of modal
    document.body.appendChild(canvas);

    const myConfetti = confetti.create(canvas, { resize: true, useWorker: true });

    // Run ESPN-style animation
    const colors = ["#3273FA", "#FFFFFF"];
    const duration = 4 * 1000;
    const end = Date.now() + duration;

    myConfetti({
      particleCount: 120,
      spread: 70,
      origin: { y: 0.6 },
      colors,
    });

    (function frame() {
      myConfetti({
        particleCount: 4,
        angle: 60,
        spread: 55,
        origin: { x: 0, y: 0 },
        colors,
      });
      myConfetti({
        particleCount: 4,
        angle: 120,
        spread: 55,
        origin: { x: 1, y: 0 },
        colors,
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    })();

    // Cleanup
    return () => {
      document.body.removeChild(canvas);
    };
  }, [trigger]);

  return null;
}
